var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuTop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18969",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18969",
    transform: "translate(-527 -141)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17435",
    "data-name": "\\u9577\\u65B9\\u5F62 17435",
    width: 39,
    height: 39,
    transform: "translate(527 141)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18968",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18968",
    transform: "translate(531 146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_930",
    "data-name": "\\u7DDA 930",
    d: "M27.212,2.9H.948a1.948,1.948,0,0,1,0-3.9H27.212a1.948,1.948,0,1,1,0,3.9Z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_931",
    "data-name": "\\u7DDA 931",
    d: "M27.212,2.9H.948a1.948,1.948,0,0,1,0-3.9H27.212a1.948,1.948,0,1,1,0,3.9Z",
    transform: "translate(1 13.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_932",
    "data-name": "\\u7DDA 932",
    d: "M27.212,2.9H.948a1.948,1.948,0,0,1,0-3.9H27.212a1.948,1.948,0,1,1,0,3.9Z",
    transform: "translate(1 25.379)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTop);
export default __webpack_public_path__ + "static/media/menuTop.bd25e3b5a8542ca9aa95c4b336445af9.svg";
export { ForwardRef as ReactComponent };